/** Origem opcional de navegação, propagada via search param `returnTo`. */
export type ModuleReturnTo = 'grade-config' | undefined;

/**
 * Resolve a rota de retorno (salvar/cancelar) do formulário de módulo. Quando o
 * fluxo foi aberto a partir da tela de Nota/Frequência (`returnTo=grade-config`),
 * volta para lá; caso contrário, volta para a listagem de módulos.
 *
 * @param returnTo - Origem informada no search param `returnTo`.
 * @returns Rota tipada de retorno para `navigate({ to })`.
 *
 * @example
 * ```ts
 * const returnPath = resolveModuleReturnPath(returnTo);
 * navigate({ to: returnPath });
 * ```
 */
export function resolveModuleReturnPath(returnTo: ModuleReturnTo) {
  return returnTo === 'grade-config' ? '/exam/grade-config' : '/class-modules';
}
